import posthog from 'posthog-js';

import type { PostHogBusinessEvent } from '@/shared/types/posthog';

/**
 * Versão do contrato de propriedades dos eventos de negócio. Suba quando mudar o significado ou o
 * conjunto de propriedades, para que o Produto consiga separar as séries no PostHog.
 */
const BUSINESS_EVENT_SCHEMA_VERSION = 1;

export function capturePageview(url: string): void {
  if (!posthog.__loaded) {
    return;
  }

  posthog.capture('$pageview', { $current_url: url });
}

/**
 * Envia só o nome do evento, o produto e a versão do contrato. O conteúdo da operação (payload,
 * argumentos do thunk) nunca entra: é dado de parte, documento ou valor de acordo (LGPD).
 */
export function captureBusinessEvent({ event, product }: PostHogBusinessEvent): void {
  if (!posthog.__loaded) {
    return;
  }

  posthog.capture(event, { product, schema_version: BUSINESS_EVENT_SCHEMA_VERSION });
}
